import cn from "classnames";
import * as uuid from "uuid";
import i from "@styles/icons.module.scss";
import s from "./Select.module.scss";

const Select = ({
  className,
  required,
  errors,
  label,
  withoutMessage,
  errorWithoutMessage,
  leadingSlot,
  ...props
}) => {
  const id = uuid.v4();
  const classes = cn(
    s.selectWrap,
    (errors || errorWithoutMessage) && s.error,
    withoutMessage && s.withoutMessage,
    className
  );
  return (
    <div className={classes}>
      {label && <label htmlFor={id}>{`${label}${required ? " *" : ""}`}</label>}
      <div className={cn(s.select, leadingSlot && s.leadingSlotWrap)}>
        {leadingSlot ? (
          <span className={s.leadingSlot}>{leadingSlot}</span>
        ) : null}
        <icon className={i.arrowBottom} />
        <select
          id={id}
          {...props}
          className={cn(props.className, leadingSlot && s.selectInputWithLeading)}
        />
      </div>
      {errors && <div className={s.message}>{errors}</div>}
    </div>
  );
};

export default Select;
